
const colorConfigs = {
  btn: {
    cancel: {
      bg: "#FFFFFF",
      color: "#167AC3",
      border: "1px solid #167AC3",
    },
    main: {
      bg: "#167AC3",
      tailwind: "bg-[#167AC3]"
    },
    delete:{
      bg: "#D92D20"
    }
  },
  color: {
    main: "#167AC3"
  },
  sidebar: {
      bg: "#ffffff",
      tailwindBg: "bg-white",
    color: "#58707b",
    hoverBg: "#eeeeee",
    activeBg: "rgba(105, 178, 232, 0.10)"
  },
  topbar: {
    bg: "#167AC3",
    color: "#92A2AB"
  },
  jumper: {
    bg: "#167AC3",
  },
  mainBg: "#ffffff",
  primaryColor: "#167AC3",
};

export default colorConfigs;